import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const ChartLayout = ({ header, subheader, children, className }) => (
  <div className={cx('drivers-chart-layout', className)}>
    {header && <div className="drivers-chart-layout__header">{header}</div>}
    {subheader && <div className="drivers-chart-layout__subheader">{subheader}</div>}
    <div className="drivers-chart-layout__body">{children}</div>
  </div>
);

ChartLayout.propTypes = {
  header: T.node,
  subheader: T.node,
  children: T.node.isRequired,
  className: T.string,
};

export default ChartLayout;
